module.exports = __webpack_public_path__ + "assets/img/bosch-u.dfa82920.png";